import { render, staticRenderFns } from "./mypage-dashboard-head.vue?vue&type=template&id=728bf392&scoped=true&"
import script from "./mypage-dashboard-head.vue?vue&type=script&lang=js&"
export * from "./mypage-dashboard-head.vue?vue&type=script&lang=js&"
import style0 from "./mypage-dashboard-head.vue?vue&type=style&index=0&id=728bf392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728bf392",
  null
  
)

export default component.exports